import { render, staticRenderFns } from "./ActionsRemoveWebsiteDomain.vue?vue&type=template&id=de3be864&lang=pug&"
import script from "./ActionsRemoveWebsiteDomain.vue?vue&type=script&lang=js&"
export * from "./ActionsRemoveWebsiteDomain.vue?vue&type=script&lang=js&"
import style0 from "./ActionsRemoveWebsiteDomain.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports